/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Neděle`
};

const da_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Søndag`
};

const de_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Sonntag`
};

const en_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Sunday`
};

const es_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Domingo`
};

const fr_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Dimanche`
};

const hu_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Vasárnap`
};

const it_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Domenica`
};

const nl_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Zondag`
};

const pl_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Niedziela`
};

const pt_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Domingo`
};

const sv_weekdays_sunday = /** @type {(inputs: {}) => string} */ () => {
	return `Söndag`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const weekdays_sunday = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.weekdays_sunday(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("weekdays_sunday", locale)
	if (locale === "cs") return cs_weekdays_sunday(inputs)
	if (locale === "da") return da_weekdays_sunday(inputs)
	if (locale === "de") return de_weekdays_sunday(inputs)
	if (locale === "en") return en_weekdays_sunday(inputs)
	if (locale === "es") return es_weekdays_sunday(inputs)
	if (locale === "fr") return fr_weekdays_sunday(inputs)
	if (locale === "hu") return hu_weekdays_sunday(inputs)
	if (locale === "it") return it_weekdays_sunday(inputs)
	if (locale === "nl") return nl_weekdays_sunday(inputs)
	if (locale === "pl") return pl_weekdays_sunday(inputs)
	if (locale === "pt") return pt_weekdays_sunday(inputs)
	return sv_weekdays_sunday(inputs)
};
export { weekdays_sunday as "weekdays.sunday" }